export const getStatistics = (state) => state.statistics

